import { render } from "./Birthday.vue?vue&type=template&id=0f3862df&scoped=true"
import script from "./Birthday.vue?vue&type=script&lang=js"
export * from "./Birthday.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-0f3862df"

export default script